import React from 'react'
import { useInView } from 'react-intersection-observer'

import Wysiwyg from '../wysiwyg'
import ContactItem from '../contactItem'
import Accordion from '../accordion'

import ButtonArrow from '../buttonArrow'

import plusIcon from '../../icons/plus.svg'
import minusIcon from '../../icons/minus.svg'

import transformLink from '../../utils/transformLink'

const AccordionList = ({data}) => {
  const { ref, inView} = useInView({ threshold: 0.3, triggerOnce: true})
  let cta = null
  
  if (data.cta !== null && data.cta !== undefined) {
    cta = (data.cta.fields) ? data.cta.fields : data.cta
  }

  const {url, contentTypeContentful} = transformLink(cta, true, false)

  return (
    <div className={`pb-2 ${inView ? 'has-anim' : ''}`} ref={ref}>
      <div className="row">
        <div className="col-12 lg-col-10 mx-auto">
          { (data.titleContent && data.titleContent !== '') &&
            <h2 className="title title-slice mb-8 scroll-anim-el">{ data.titleContent }</h2>
          }

          <div className={`scroll-anim-el ${data.titleContent && data.titleContent !== '' ? 'scroll-anim-el--2' : ''}`}>
            { data.items.map((item, i) => { 
              const accordion = (item.fields) ? item.fields : item
              const content = accordion.content

              let ctaItem = null
    
              if (accordion.cta !== null && accordion.cta !== undefined) {
                ctaItem = (accordion.cta.fields) ? accordion.cta.fields : accordion.cta
              }

              const subLink = transformLink(ctaItem, true, false)
              const urlItem = subLink.url
              const contentTypeContentfulItem = subLink.contentTypeContentful

              return (
                <Accordion 
                  key={i}
                  type="title"
                  titleLevel={data.titleContent ? 3 : 2}
                  prefixClass="accordion-slice"
                  iconClosed={plusIcon.url}
                  iconOpen={minusIcon.url}
                  button={accordion.title} >
                  <>
                    <span className="text-label text-night mb-4 block">{accordion.subtitle1}</span>

                    <Wysiwyg document={content} classes={accordion.subtitle2 || accordion.contactItems ? 'mb-7 md:mb-8' : ''} />

                    { accordion.subtitle2 &&
                      <span className="text-label text-night mb-4 block">{accordion.subtitle2}</span>
                    }

                    { accordion.contactItems &&
                      <div className="flex flex-wrap">
                        { accordion.contactItems.map((contactItem, i) => { 
                          return(
                            <div className="md:w-1/2 mb-7 md:mb-8 md:pr-8" key={i}>
                              <ContactItem type="accordion" data={contactItem} />
                            </div>
                          )
                        }) }
                      </div>
                    }

                    { ctaItem !== null &&
                      <div className="mt-6 md:mt-8 mb-7 md:mb-8">
                        <ButtonArrow text={ ctaItem.label } link={urlItem} contentType={contentTypeContentfulItem} color="night" />
                      </div>
                    }
                  </>
                </Accordion>
              )
            }) }
          </div>

          { cta !== null &&
            <div className={`mt-6 md:mt-8 scroll-anim-el ${data.titleContent && data.titleContent !== '' ? 'scroll-anim-el--3' : 'scroll-anim-el--2'}`}>
              <ButtonArrow text={ cta.label } link={url} contentType={contentTypeContentful} color="night" />
            </div>
          }
        </div>
      </div>
    </div>
  )
}

export default AccordionList
